module.exports = __webpack_public_path__ + "static/NanumSquareR-1d2032162df7cc5a15dc6657c602a55c.eot";